import Hero from "@/components/Hero";

export function Home() {
  return (
    <main>
      <Hero />
    </main>
  );
}

export default Home;
